var r=function(r){var t=r.trim().replace(/\D/g,"").substring(0,8);if(!t)return"";var e=t.match(/.{1,2}/g);return e.length>3&&(e[2]=t.slice(4),e.pop()),e.join("/")};export{r as sanitizeDateInput};
